import React from 'react';

import OrderPostProcessorsEdit from './Edit';

// Thin wrapper so that /order_post_processors/new resolves to a dedicated
// component rather than re-using the Edit page directly. The underlying
// Edit component already handles the "new" case via useParams (id undefined).
export default function AdminOrderPostProcessorNew() {
  return <OrderPostProcessorsEdit />;
}
